<ion-list lines="none">
  <ion-item
    *ngIf="
      (role$ | async) >= roleLimits.RECORDING_READ && (recording.wav || recording.mp4 || recording.mixed) && !recording.screenRecording
    "
    (click)="openEditInDescriptMenu()"
    button="true">
    <ion-icon src="/assets/icons/24px/descript.svg" slot="start" class="descript"> </ion-icon>

    <ion-label class="ion-text-wrap"> Edit in Descript </ion-label>

    <ion-icon src="/assets/icons/24px/chevron-right.svg" slot="end"> </ion-icon>
  </ion-item>

  <ion-item
    *ngIf="(role$ | async) >= roleLimits.RECORDING_READ && (recording.wav || recording.mp4 || recording.mixed)"
    (click)="openDownloadMenu()"
    button="true">
    <ion-icon src="/assets/icons/24px/download.svg" slot="start"> </ion-icon>

    <ion-label class="ion-text-wrap"> Download </ion-label>

    <ion-icon src="/assets/icons/24px/chevron-right.svg" slot="end"> </ion-icon>
  </ion-item>

  <ion-item
    *ngIf="(role$ | async) >= roleLimits.RECORDING_READ && (recording.wav || recording.mp4 || recording.mixed)"
    (click)="copyLink($event)"
    button="true">
    <ion-icon src="/assets/icons/24px/link.svg" slot="start"> </ion-icon>

    <ion-label class="ion-text-wrap"> Copy Share Link </ion-label>

    <ion-icon src="/assets/icons/24px/chevron-right.svg" slot="end"> </ion-icon>
  </ion-item>
  <!-- 
  <ion-item *ngIf="!recording.enhanced && (role$ | async) >= roleLimits.RECORDING_READ" button="true">
    <ion-icon src="/assets/icons/24px/nerd.svg" slot="start"> </ion-icon>

    <ion-label class="ion-text-wrap">
      Stats for Nerds
      <p>Coming Soon</p>
    </ion-label>
  </ion-item> -->

  <ion-item
    *ngIf="
      (role$ | async) >= roleLimits.RECORDING_DELETE &&
      !recording.preview &&
      (recording.wav || recording.mp4 || recording.error || recording.mixed)
    "
    (click)="openDeleteRecordingModal()"
    button="true">
    <ion-icon src="/assets/icons/24px/delete.svg" slot="start"> </ion-icon>

    <ion-label class="ion-text-wrap"> Delete Recording </ion-label>
  </ion-item>

  <ion-item
    *ngIf="!enhanced && !recording.mixed && (role$ | async) >= roleLimits.RECORDING_CREATE"
    (click)="[reRenderRecording(), timeoutRerender()]"
    [disabled]="!enableRenderBtn && !enhanced && !recording.mixed"
    button="true">
    <ion-icon src="/assets/icons/24px/backups.svg" slot="start"> </ion-icon>
    <ion-label class="ion-text-wrap">
      {{ enableRenderBtn ? 'Retry Rendering' : 'Rendering...' }}
    </ion-label>
  </ion-item>
</ion-list>
